<template lang="pug">
.marketing-consent-wrapper(v-if="!isHidden")
  .consent-checkbox-container
    el-checkbox(v-model="isChecked")
      span.consent-label
        | I agree to share my name, email, and purchase information with {{ organizationName }} and allow them to use it for marketing campaigns
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'MarketingConsentCheckbox',
  props: {
    organizationName: {
      type: String,
      required: true,
    },
    organizationId: {
      type: String,
      default: null,
    },
  },
  emits: [],
  setup(props, { expose }) {
    const isChecked = ref(false);

    // Don't show checkbox if organizationId is not provided
    const isHidden = ref(!props.organizationId);

    const getConsentValue = () => isChecked.value;

    // Expose method to parent component
    expose({
      getConsentValue,
    });

    return {
      isChecked,
      isHidden,
      getConsentValue,
    };
  },
});
</script>

<style lang="scss" scoped>
.marketing-consent-wrapper {
  margin: 0;
}

.consent-checkbox-container {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  position: relative;
}

.consent-label {
  font-size: 0.75rem;
  line-height: 1.35;
  color: #4a5568;
}

:deep(.el-checkbox) {
  align-items: flex-start;
  height: auto;

  .el-checkbox__label {
    white-space: normal;
    line-height: 1.3;
    font-size: 0.72rem;
    padding-left: 6px;
  }

  .el-checkbox__inner {
    margin-top: 2px;
  }
}
</style>
